

    
<div #header class="flex-row flex--align-center flex--justify-between border-primary-bottom full-width padding-standard primary-background-A200-transparent">

    <div class="flex-column ">
        <h4 class="mat-headline-4 margin-none primary-text">{{actorDisplay}}</h4>
        <h6 class="mat-body-1 margin-none">{{actor.email}}</h6>
    </div>
    <button mat-icon-button 
            (click)="cancel()"
    >
    <mat-icon>close</mat-icon> 
    </button> 

</div>


<div fixedScroll [otherElements]="[header,footer]">

    <div class="full-height position-relative display-block" >

        <ss-actor-splug-info></ss-actor-splug-info>

        <ng-container *ngIf="externalSubject | async">
            <ss-actor-auth-checklist></ss-actor-auth-checklist>
        </ng-container>

        <ss-core-loader-outlet class="full-height" [keys]="['splug.validate']"></ss-core-loader-outlet>

    </div>

</div>

<div #footer class="padding-standard flex-row flex--justify-between flex--align-center border-primary-top">
    
    <div class="flex-row gap-standard flex--align-center">
        <button     
            libLoaderButton 
            [keys]="['splug.validate','splug-parameters-cofinguration.insert-batch']" 
            mat-raised-button 
            color="primary" 
            (click)="validateAndSave()"
        >
            <mat-icon>done</mat-icon> 
            {{'ss-general.done' | translate}}
        </button>

        <button color="primary" 
                mat-raised-button 
                libLoaderButton
                [keys]="['splug.validate']" 
                (click)="validate()"
        >
            <mat-icon>done</mat-icon>
            {{'ss-general.validate' | translate}}
        </button>
    </div>

    <button     mat-raised-button 
                (click)="cancel()"
    >
        <mat-icon color="black">cancel</mat-icon> 
        {{'ss-general.cancel' | translate}}
    </button>
</div>


